function NewVideo() {
  return (
    <>
      <div className="new-video-container">
        <img src="/reel-icon.svg" alt="video icon" />
        <p>New Video</p>
      </div>
    </>
  );
}

export default NewVideo;
